import React from 'react';

import { Box, Grid, GridItem } from '@chakra-ui/react';
import { MenuItem } from '@material-ui/core';
import { onNotificationClickActionApi } from 'api/notifications';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import {
  EngagementIconDualTone,
  FeedbackIconDualTone,
  OneOnOneIconDualTone,
  ReviewsIconDualTone,
} from 'assets/assetsV1/iconComponents';

// import TextParseComponent from 'components/feed/TextParseComponent';
import { getShortHumanReadableDate } from 'constants/helper';
import { sendNotificationClickedEvent } from 'constants/mixpanelHelper';

import { Avatar } from 'uiToolkitV1/Avatar';
import { TextParseComponent } from 'uiToolkitV1/TextParseComponent';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const NOTIFICATION_TYPES_ICON_MAP = {
  REVIEW: ReviewsIconDualTone,
  ONE_ON_ONE: OneOnOneIconDualTone,
  FEEDBACK: FeedbackIconDualTone,
  ENGAGEMENT: EngagementIconDualTone,
};

const NotificationImage = ({ source, type, isUnread }) => {
  if (source?.image) {
    return (
      <Avatar position="relative" notificationCount={0} size={32} src={source.image}>
        {isUnread && <UnreadNotificationDot />}
      </Avatar>
    );
  }
  if (NOTIFICATION_TYPES_ICON_MAP[type]) {
    const Icon = NOTIFICATION_TYPES_ICON_MAP[type];
    return (
      <IconBG>
        <Icon boxSize="22px" />
        {isUnread && <UnreadNotificationDot />}
      </IconBG>
    );
  }
  return (
    <Avatar position="relative" notificationCount={0} size={32} src={source.image}>
      {isUnread && <UnreadNotificationDot />}
    </Avatar>
  );
};

function NotificationComponent({ updateIsClicked, data, closePopup, showDetails, closeMenu }) {
  const history = useHistory();
  const { id, isClicked, source, text, macros, createdDate, type } = data;
  const mouseDown = (e) => {
    e.stopPropagation();
  };
  const onClick = () => {
    if (!isClicked) {
      onNotificationClickActionApi(id).then((res) => updateIsClicked(id));
    }
    if (data.url) {
      sendNotificationClickedEvent({
        eventProperties: {
          path: data.getUrl(),
          text,
        },
      });
      const pathname = data.getUrl();
      history.push(pathname);
      closePopup();
      // runFnIfValid(closeMenu);
      closeMenu();
      return true;
    }
    switch (data.type) {
      case 'TASK':
        sendNotificationClickedEvent({
          eventProperties: {
            taskIds: data.landingPageIds,
            text,
          },
        });
        showDetails(data.landingPageIds);
        break;
      case 'GOAL':
        showDetails(data.landingPageIds);
        break;
      default:
        sendNotificationClickedEvent({
          eventProperties: {
            path: data.getUrl(),
            text,
          },
        });
        history.push(data.getUrl());
    }
    closePopup();
    // runFnIfValid(closeMenu);
    closeMenu();
  };

  const isUnread = !isClicked;

  return checkNewNavEnabled() ? (
    <StyledMenuItemNewNav onClick={onClick} onMouseDown={mouseDown} displayBorder disableRipple disableFocusRipple>
      <NotificationImage isUnread={isUnread} source={source} type={type} />
      <Box>
        <TextBodyMedium
          sx={{
            span: {
              cursor: 'pointer',
            },
          }}
        >
          <TextParseComponent text={text} macros={macros} />
        </TextBodyMedium>
        <TextLabel color="text.g2">{getShortHumanReadableDate(createdDate)}</TextLabel>
      </Box>
    </StyledMenuItemNewNav>
  ) : (
    <StyledMenuItem onClick={onClick} onMouseDown={mouseDown} displayBorder disableRipple disableFocusRipple>
      <Grid templateColumns="1fr 8fr" w="100%">
        <GridItem display="flex" alignItems="center" justifyContent="center">
          {' '}
          <NotificationImage isUnread={isUnread} source={source} type={type} />
        </GridItem>
        <GridItem ml="8px" display="flex" flexDir="column">
          <TextBodyMedium
            sx={{
              span: {
                cursor: 'pointer',
              },
            }}
          >
            <TextParseComponent text={text} macros={macros} />
          </TextBodyMedium>
          <TextLabel color="text.g2">{getShortHumanReadableDate(createdDate)}</TextLabel>
        </GridItem>{' '}
      </Grid>
    </StyledMenuItem>
  );
}

const StyledMenuItemNewNav = styled(MenuItem)`
  display: flex !important;
  padding: 8px 12px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid #f5f7f9;
  margin-bottom: 12px;

  svg {
    color: #fff !important;
  }
  &:active {
    background: #e6f1fd;
  }
  &:focus {
    background: #e6f1fd;
  }
  &:hover {
    background: #e6f1fd;
    p {
      color: #333333;
    }
    svg {
      color: #fff !important;
    }
  }
  cursor: pointer;
`;

const StyledMenuItem = styled(MenuItem)`
  display: flex !important;
  align-items: center;
  border-radius: 8px;
  min-height: 60px;
  padding: 8px;

  svg {
    color: #fff !important;
  }
  &:active {
    background: #e6f1fd;
  }
  &:focus {
    background: #e6f1fd;
  }
  &:hover {
    background: #e6f1fd;
    p {
      color: #333333;
    }
    svg {
      color: #fff !important;
    }
  }
  cursor: pointer;
`;

const UnreadNotificationDot = styled('div')`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  position: absolute;
  top: -2px;
  right: -2px;
  background: #c62c02;
`;

const IconBG = styled('div')`
  height: 32px;
  width: 32px;
  background: #ebeff3;
  position: relative;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default NotificationComponent;
